
seedWebServices.service('WorkflowService', ['$http', '$cacheFactory', '$uibModal', 'AllocService',
    function ($http, $cacheFactory, $uibModal, AllocService) {

        var serviceCache = $cacheFactory('WorkflowService');
        var baseUrl = '../Api/Workflow';

        this.resetCache = function () {
            console.log('StoreServiceResetCache');
            serviceCache.removeAll();
        };

        this.getSalesWorkflow = function () {
            return $http.get(baseUrl + '/GetSalesWorkflow', {
                params: {  },
                cache: serviceCache
            });
        };       

        this.canShowExpirationDate = function (item) {
            return item.StatusID == 'RESERVED' || item.StatusID == 'EXPIRED' || item.StatusID == 'EXPIRING' ||
                item.StatusID == 'CONFIRMED' || item.StatusID == 'CONFIRMED_EXPIRING' || item.StatusID == 'CONFIRMED_EXPIRED';
        };

        this.canRenovateExpired = function (order) {
            if (order.StatusID == 'EXPIRING' || order.StatusID == 'CONFIRMED_EXPIRING') {
                return true;
            }
            else if (order.StatusID == 'EXPIRED' || order.StatusID == 'CONFIRMED_EXPIRED') {
                return true;
            }
            else if (order.StatusID == 'RESERVED' || order.StatusID == 'CONFIRMED') {
                var isExpiring = AllocService.isExpiring(order.ExpirationDate);
                return isExpiring;
            }
            return false;
        };

        this.canEditOrder = function (order) {
            if (order.OrderID == 'NEW_QUOTE') {
                return false;
            }
            return order.StatusID == '00_NEW_QUOTE' || order.StatusID == '02_QUOTE_WAITING' || order.StatusID == '04_QUOTE_PARTIAL';            
        };

        //this.isStatusNotAccounted = function (item) {
        //    return item.StatusID == 'EXPIRED' ||
        //        item.StatusID == 'CONFIRMED_EXPIRED' ||
        //        item.StatusID == 'CANCELED' ||
        //        item.StatusID == 'SAP_ARCHIVED';
        //};

        this.isJustificationNeeded = function (statusID) {
            return statusID == 'EXPIRED' || statusID == 'CONFIRMED_EXPIRED';
        };

        this.getStatusReserved = function () {
            //return 'RESERVED';
            return '1';
        };

        this.isStatusByOrder = function (statusID) {
            return statusID == 'DRAFT' || 
                statusID == 'RESERVED';
        }


        this.getStatusNewQuote = function () {
            return '00_NEW_QUOTE';            
        };
    }]);